module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_SkipToEnd_16"],"path":[{"$":{"d":"M14,13H12V3h2ZM2,3V13l9-5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_SkipToEnd_16.svg
// module id = vJky
// module chunks = 1